import { Modal } from "react-bootstrap";
import ModifierComboGroupContainer from "./ModifierComboGroupContainer.js";
import ErrorAlert from "../../../../common/ui/ErrorAlert.js";
import * as CommonUtilities from "../../../../common/utils/CommonUtils";

export default function ModifierComboGroupsListModalPage(props) {
    // Returns the modal page that contains the groups / selection within the selected Modifier Combo
    
    // Combo Pricing 
    let comboPriceNum = parseFloat(props.modifierComboGroupFormData.modComboPriceInc);
    let groupPricesNum = 0;
    props.modifierComboGroupFormData.modComboGroups.forEach((group) => {
        // ⚠ The undefined guard is load-bearing, not defensive padding. A group
        // the customer has not chosen yet has no PriceInc, and parseFloat(undefined)
        // is NaN — which makes the WHOLE combo total render as NaN, not just this
        // line. Keep it.
        if (group.PriceInc === undefined) {
            groupPricesNum += parseFloat(0);
        } else {
            groupPricesNum += parseFloat(group.PriceInc);
        }
    });
    let totalPriceNum = comboPriceNum + groupPricesNum;
    let totalPriceToDisplay = CommonUtilities.formatDisplayPrice(totalPriceNum);

    // Groups
    let modifierComboGroups;
    if (props.modifierComboDetails.modifierComboDetails.modComboGroups.length > 0) {
        let modComboGroupIndex = -1;
        modifierComboGroups = props.modifierComboDetails.modifierComboDetails.modComboGroups.map((item, index) => {
            modComboGroupIndex += 1;
            return (
                <ModifierComboGroupContainer 
                    key={modComboGroupIndex}
                    modComboGroupIndex={modComboGroupIndex}
                    modComboGroupFormData={props.modifierComboGroupFormData.modComboGroups[index]}
                    modifierComboGroupDetails={item} // Passing just the specific group in the modifier combo
                    handleModifierComboGroupSelect={props.handleModifierComboGroupSelect}
                />
            )
        })
    } else {
        modifierComboGroups = <></>
    }

    return (
        <>
            <Modal.Body className="wo-pm__body">
                <div className="wo-pm__intro">
                    <h3 className="wo-pm__name">{props.modifierComboDetails.modifierComboDetails.modLinkedToCombo.modName}</h3>
                    {props.modifierComboDetails.modifierComboDetails.modCategoryDescription &&
                        <p className="wo-pm__desc">{props.modifierComboDetails.modifierComboDetails.modCategoryDescription}</p>}
                    <p className="wo-pm__price">{totalPriceToDisplay}</p>
                </div>
                <div className="wo-pm__options row g-0">
                    {modifierComboGroups}
                </div>
            </Modal.Body>
            <Modal.Footer className="wo-pm__foot">
                { props.errorModifierCombo.GroupsListPage.HasError && <div className="wo-pm__footErr"><ErrorAlert message={props.errorModifierCombo.GroupsListPage.ErrorMessage} /></div> }
                { props.currentLocation.AllowOnlineOrder && props.currentLocation.Validation.IsValidTableNumber &&
                     <div className="wo-pm__footBar">
                        <button type="button" className="wo-pm__add" onClick={props.handleModComboAddComboToProduct} disabled={props.errorModifierCombo.GroupsListPage.ButtonsDisabled}>
                            Add combo to product
                            { props.errorModifierCombo.GroupsListPage.ButtonsDisabled && <>&ensp;<span className="spinner-border spinner-border-sm" aria-hidden="true"></span></> }
                        </button>
                     </div>
                }
            </Modal.Footer>
        </>
    )
}